module.exports = function() {
  return new Worker(__webpack_public_path__ + "93fe27af692d88136ddf.worker.js");
};